















import { Component, Vue } from 'vue-property-decorator';
import ImageManager from '@/script/ImageManager';
import TextManager from '@/script/TextManager';
import {getSizeRatio} from '@/script/common';

@Component
export default class StumpExample extends Vue {
  private stump1: string = ImageManager.INSTANCE.get('スタンプ例１')!;
  private stump2: string = ImageManager.INSTANCE.get('スタンプ例２')!;
  private stump3: string = ImageManager.INSTANCE.get('スタンプ例３')!;
  private stump4: string = ImageManager.INSTANCE.get('スタンプ例４')!;
  private introductionText: string = TextManager.INSTANCE.get('introduction-text')!;

  private imgSize: number = 300;

  private created() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  }

  private onResize() {
    // フレームのサイズを調整
    const frameWidth = 300;
    const sizeRatio = getSizeRatio(frameWidth);

    this.imgSize = frameWidth * sizeRatio;
  }
}
